var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container",attrs:{"id":"undelegations_table"}},[_c('BaseGrid',{attrs:{"sort":_vm.sort,"columns":_vm.columns,"data":_vm.data,"onRowClick":_vm.onClickValidator}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }